/**
 * RESPONSIBILITY: the Sermons page's head.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.SermonsHero, label: 'Sermons — page head' })
export class SermonsHeroSection {
  @Text({ label: 'Subtitle', maxLength: 120, default: 'Resources', description: ABOVE_HINT })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'Sermons' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  intro!: string;
}
